import { DomSanitizer } from '@angular/platform-browser';

import {
  PeFormInstanceWorkflowHistoryRecordApiModel,
  PeFormInstancePerformanceCategoryApiModel,
  PeFormInstanceQuestionApiModel,
  PeFormInstanceQuestionHeadingApiModel
} from '.';
import { PerformanceCategoriesSupport, QuestionSupport, ProgramRole } from '@app/shared/enums';
import { PeFormResponseType } from '@app/shared/enums/pe-form-response-type.enum';
import { IncidentsSupport } from '@app/shared/enums/incidents-support.enum';
import { FormsSupport } from '@app/shared/enums/forms-support.enum';

import { IncidentApiModel } from './IncidentApiModel';
import { UserListApiModel } from '../users/UserListApiModel';
import { FormInstancePerformanceCategoryBaseApiModel } from '../program/shared/form-instances/FormInstancePerformanceCategoryBaseApiModel';
import { FormInstanceRatingApiModel } from '../program/shared/form-instances/FormInstanceRatingApiModel';
import { PipFormInstanceDetailsApiModel } from '../program/pip';

export class PeFormInstanceApiModel {
  public Id: number;
  public Name: string;
  public FormId: number;
  public IncidentsSupport: IncidentsSupport;
  public Incident: IncidentApiModel;
  public PerformanceCategoriesSupport: PerformanceCategoriesSupport;
  public QuestionSupport: QuestionSupport;
  public CurrentComment: string;
  public CurrentStepId: number;
  public CurrentStepName: string;
  public CurrentStepResponseType: PeFormResponseType;
  public ShiftId: number | null;
  public ShiftName: string;
  public LocationId: number | null;
  public LocationName: string;
  public CreatorNarrative: string;
  public HasCreatorNarrative: boolean;
  public SubjectNarrative: string;
  public HasSubjectNarrative: boolean;
  public IsRejected: boolean;
  public IsSubmitted: boolean;
  public MinDate: Date;
  public ActualMinDate: string;
  public MaxDate: Date;
  public ActualMaxDate: string;
  public WorkDate: Date;
  public ActualWorkDate: string;
  public DueDate: Date;
  public SubjectUserId: string;
  public CreatorUserId: string;
  public SubjectFullName: string;
  public CreatorFullName: string;
  public SubjectAvatarSrc: string;
  public SubjectJobTitleName: string;
  public SubjectIdNumber: string;
  public SubjectRole: ProgramRole;
  public SubjectProgramRoleId: string;
  public CreatorProgramRoleId: string;
  public UserAboutDescription: string;
  public IsEditable: boolean;
  public IsHeaderEditable: boolean;
  public IsDeletable: boolean;
  public IsActionable: boolean;
  public IsCritique: boolean;
  public InstanceNumber: string;
  public FormsSupport: FormsSupport;
  public HasFormsSupportingDocuments: boolean;
  public HasSummarySupportingDocuments: boolean;
  public HasSnapshot: boolean;
  public HasAboutAndInterests: boolean;
  public HasGoals: boolean;
  public HasCitizenFeedback: boolean;
  public HasTrainingCourseClasses: boolean;
  public DisplayRelatedPerformanceData: boolean;
  public DisplayHistoryToSubject: boolean;
  public DisplayCategoryAverage: boolean;
  public NextUsers: Array<UserListApiModel>;
  public ForbiddenInstanceNumbers: Array<string>;
  public PerformanceCategories: Array<FormInstancePerformanceCategoryBaseApiModel>;
  public Questions: Array<PeFormInstanceQuestionApiModel | PeFormInstanceQuestionHeadingApiModel>;
  public MostAcceptablePerformanceCategories: Array<PeFormInstancePerformanceCategoryApiModel>;
  public LeastAcceptablePerformanceCategories: Array<PeFormInstancePerformanceCategoryApiModel>;
  public Ratings: Array<FormInstanceRatingApiModel>;
  public History: Array<PeFormInstanceWorkflowHistoryRecordApiModel>;
  public RequireWorkflowComment: boolean;
  public RequireNextUserSelection: boolean;
  public Pip: PipFormInstanceDetailsApiModel | null;

  public deserialize(data: object, sanitizer: DomSanitizer): this {
    Object.assign(this, data);

    if (this.Incident) {
      this.Incident = new IncidentApiModel().deserialize(this.Incident, sanitizer);
    }

    this.WorkDate = new Date(this.WorkDate);
    this.MinDate = new Date(this.MinDate);
    this.MaxDate = new Date(this.MaxDate);

    this.Pip = this.Pip ? new PipFormInstanceDetailsApiModel().deserialize(this.Pip) : null;

    return this;
  }
}
